// Daten-Kontrakt v1 (Viewer-Seite).
// ACHTUNG: bewusst dupliziert im Backend (src/template/contract/contract-v1.ts)
// und im SDK (vcard-template-sdk/sdk/src/types.ts) — Änderungen an allen drei Stellen.
import type { ReactElement } from 'react';

export const SUPPORTED_CONTRACT_VERSIONS = [1];

export interface DayTime {
  day: number;
  time: string; // HHMM, z. B. "0900"
}

export interface ContextOpeningHour {
  open: DayTime;
  close: DayTime;
}

export interface ContextTeam {
  name?: string;
  logo?: string;
  address?: Record<string, unknown>;
  openingHours?: ContextOpeningHour[];
}

export interface VcardContextData {
  vcard: {
    firstName?: string;
    lastName?: string;
    role?: string;
    profileImage?: string;
    email?: string;
    phone?: string;
    mobile?: string;
    whatsapp?: string;
    facebook?: string;
    linkedin?: string;
    website?: string;
    googleBusinessMessage?: string;
    team?: ContextTeam;
  };
  brand: {
    name?: string;
    primaryColor?: string;
    logo?: string;
    signet?: string;
    claim?: string;
  };
}

export interface TemplateRef {
  id: string;
  name: string;
  version: string;
  contractVersion: number;
  capabilities: string[];
  bundleUrl: string;
  stylesUrl?: string;
  assetBaseUrl: string;
  preview?: string;
}

export interface VcardViewPayload {
  kind?: 'vcard';
  contractVersion: number;
  context: VcardContextData;
  template: TemplateRef | null;
}

export interface TemplateProps {
  data: VcardContextData;
  asset: (name: string) => string;
}

export type TemplateComponent = (props: TemplateProps) => ReactElement | null;

export interface SiteContextData {
  brand: VcardContextData['brand'];
}

export interface LandingProps {
  data: SiteContextData;
  asset: (name: string) => string;
}
export interface ErrorProps {
  data: SiteContextData;
  asset: (name: string) => string;
  error: { kind: 'notFound'; urlKey?: string };
}
export type LandingViewComponent = (props: LandingProps) => ReactElement | null;
export type ErrorViewComponent = (props: ErrorProps) => ReactElement | null;

export type ViewKind = 'vcard' | 'notFound' | 'landing';
export interface NotFoundPayload {
  kind: 'notFound';
  contractVersion: number;
  context: SiteContextData;
  template: TemplateRef | null;
  urlKey?: string;
}
export interface LandingPayload {
  kind: 'landing';
  contractVersion: number;
  context: SiteContextData;
  template: TemplateRef | null;
}
export type ViewPayload = VcardViewPayload | NotFoundPayload | LandingPayload;
